import React, { useState, useEffect } from 'react';
import './App.css';
import axios from 'axios';
import logoImg from './Logo1.png';
import landingImg from './landing-image.png';
import landingImg1 from './landing-image1.png';
import landingImg2 from './landing-image2.png';
import powerbyresearchImg from './powerbyresearch.png';
import brandneutralImg from './brandneutral.png';
import tailedrecommendationsImg from './tailedrecommendations.png';
import smartSelectEssentialImg from './smartselectessential.png';
import smartSelectPlusImg from './smartselectplus.png';
import smartSelectPremiumImg from './smartselectpremium.png';
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
// Brand: use image (PNG) instead of plain text name
const companyName = logoImg;
const companyNameText = 'iAutocrew Solutions';
const landingImages = [landingImg, landingImg1, landingImg2];
const App = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [flippedCards, setFlippedCards] = useState({});
  const [currentLandingImage, setCurrentLandingImage] = useState(0);
  const [flippedPackages, setFlippedPackages] = useState({});
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    phone: '',
    car_preferences: ''
  });
  const [formStatus, setFormStatus] = useState({
    isSubmitting: false,
    isSubmitted: false,
    error: null
  });

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentLandingImage((prevIndex) => (prevIndex + 1) % landingImages.length);
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  const toggleServiceCard = (index) => {
    setFlippedCards(prev => ({ ...prev, [index]: !prev[index] }));
  };

  const togglePackageCard = (index) => {
    setFlippedPackages(prev => ({ ...prev, [index]: !prev[index] }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'phone') {
      const digitsOnly = value.replace(/\D/g, '').slice(0, 10);
      setContactForm(prev => ({
        ...prev,
        [name]: digitsOnly
      }));
    } else {
      setContactForm(prev => ({
        ...prev,
        [name]: value
      }));
    }

    setFormStatus(prev => ({ ...prev, error: null }));
  };

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    if (contactForm.phone.length !== 10) {
      setFormStatus({
        isSubmitting: false,
        isSubmitted: false,
        error: 'Please enter a 10-digit phone number.'
      });
      return;
    }

    setFormStatus({ isSubmitting: true, isSubmitted: false, error: null });

    try {
      const response = await axios.post(`${API}/contact`, contactForm);
      console.log('Contact form submitted successfully:', response.data);

      if (window.gtag) {
        window.gtag('event', 'conversion', {
          send_to: 'AW-17848511607/KleuCNSntaQcEPfY6r5C'
        });
      }
      
      setFormStatus({ 
        isSubmitting: false, 
        isSubmitted: true, 
        error: null 
      });
      
      // Reset form
      setContactForm({
        name: '',
        email: '',
        phone: '',
        car_preferences: ''
      });

    } catch (error) {
      console.error('Error submitting contact form:', error);
      setFormStatus({ 
        isSubmitting: false, 
        isSubmitted: false, 
        error: 'Failed to submit form. Please try again.' 
      });
    }
  };

  const scrollToContact = () => {
    document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
  };

  const handlePhoneCallClick = () => {
    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: 'AW-17848511607/qsmGCJaFuNsbEPfY6r5C'
      });
    }
  };

  const services = [
    {
      title: "Powered By Research",
      description: "Every recommendation we make is based on data research — not opinions. We analyze market trends, pricing, and dealer performance to find the best options for you.",
      image: powerbyresearchImg
    },
    {
      title: "Brand Neutral",
      description: "We’re not biased by  specific brands— our advice is driven by your needs.",
      image: brandneutralImg
    },
    {
      title: "Tailored Recommendations",
      description: "Every recommendation is shaped by what matters to you — to ensure the best possible match",
      image: tailedrecommendationsImg
    }
  ];

  const packages = [
    {
      image: smartSelectEssentialImg,
      description: 'A focused starter package designed to give you clear direction. We help you shortlist a few suitable cars, review listings, and provide essential tips so you can move forward with confidence.'
    },
    {
      image: smartSelectPlusImg,
      description: 'A balanced, full-service package covering deeper research across multiple models, detailed comparisons, and history checks. We prepare you with negotiation insights and send fresh options until you find the right fit.'
    },
    {
      image: smartSelectPremiumImg,
      description: 'Our concierge-style service for serious buyers. From in-depth research and detailed comparisons to negotiation support and post-purchase advice — we stay with you every step of the way until you drive your car home.'
    }
  ];

  const testimonials = [
    {
      name: "Sarah Johnson",
      role: "First-time Car Buyer",
      content: "iCrew saved me over $4,000 on my new SUV! The process was so smooth and stress-free.",
      rating: 5
    },
    {
      name: "Mike Chen",
      role: "Business Owner",
      content: "Amazing service! They handled everything while I focused on my business. Highly recommended!",
      rating: 5
    },
    {
      name: "Lisa Rodriguez",
      role: "Working Mom",
      content: "No more spending weekends at dealerships. iCrew got me the perfect family car in just 2 days.",
      rating: 5
    }
  ];

  const faqs = [
    {
      question: "Do you sell cars?",
      answer: "No. We don’t sell cars or work for any dealership. We provide independent, research-driven advice to help you find the right car at the right price."
    },
    {
      question: "How much can I save?",
      answer: "On average we project to save a few hundereds to thousands CAD through our research, market analysis, and negotiation support. Savings may vary depending on the vehicle, market conditions, and package selected."
    },
    {
      question: "How are you different from a dealership or broker?",
      answer: "Dealerships want to sell you their cars, and brokers often earn commissions. At iAutoCrew, we work only for you. Our recommendations are brand-neutral and unbiased, built around your needs, budget, and goals."
    },
    {
      question: "Are you getting commission from dealers?",
      answer: "No. We never accept commissions or incentives from dealerships. We work exclusively for our clients, ensuring that our advice remains fully independent and unbiased."
    },
    {
      question: "How do I know the details of what’s included in each package?",
      answer: "We’ll walk you through the full package details during your initial intake call. This way, you’ll have clarity on what’s included, the scope of work, and the value you’ll receive before committing."
    },
        {
      question: "What if you don’t find a car that fits my needs?",
      answer: "If we can’t identify a suitable match within your budget or requirements, we’ll be transparent and share our findings. In such cases, we may provide alternative options or even refund our base fee depending on the package chosen."
    },
    {
      question: "Do you provide Carfax or vehicle history reports?",
      answer: "Yes — in our higher-tier packages, we include VIN checks and vehicle history reviews. For Essentials, we guide you on obtaining these reports so you can still make an informed decision."
    },
    {
      question: "What types of vehicles do you cover?",
      answer: "For new cars, we focus on regular consumer vehicles (not luxury, premium, trucks, or fleet purchases). For used cars, we cover personal-use vehicles only — not fleets or rentals."
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#01070f] via-[#01040a] to-[#01070f]">
      {/* Navigation */}
      <nav className="fixed top-0 w-full bg-white/10 backdrop-blur-lg border-b border-white/20 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
              <span className="text-white font-bold text-xl">{ companyNameText } </span>
            <div className="hidden md:flex space-x-8">
              <a href="#aboutus" className="text-white/80 hover:text-white transition-colors duration-300">About Us</a>
              <a href="#services" className="text-white/80 hover:text-white transition-colors duration-300">Why Choose Us</a>
              <a href="#packages" className="text-white/80 hover:text-white transition-colors duration-300">Packages</a>
              <a href="#how-it-works" className="text-white/80 hover:text-white transition-colors duration-300">How It Works</a>
              {/* <a href="#testimonials" className="text-white/80 hover:text-white transition-colors duration-300">Reviews</a> */}
              <a href="#contact" className="text-white/80 hover:text-white transition-colors duration-300">Contact</a>
            </div>
            <button 
              onClick={scrollToContact}
              className="bg-gradient-to-r from-blue-600 to-cyan-600 text-white px-6 py-2 rounded-full font-semibold hover:from-blue-700 hover:to-cyan-700 transition-all duration-300 transform hover:scale-105"
            >
              Get Started
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="pt-24 pb-16 px-4 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600/20 to-cyan-600/20"></div>
        <div className="max-w-7xl mx-auto relative">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className={`space-y-8 transition-all duration-1000 transform ${isVisible ? 'translate-x-0 opacity-100' : '-translate-x-12 opacity-0'}`}>
              <div className="space-y-6">
                {/* <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2 border border-white/20">
                  <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
                  <span className="text-white/90 text-sm">Trusted by 10,000+ Car Buyers</span>
                </div> */}
                <h1 className="text-5xl lg:text-7xl font-bold text-white leading-tight">
                  Explore. Compare. Drive Smarter
                </h1>
                <p className="text-xl text-white/80 leading-relaxed max-w-lg">
                  Our experience with cars and research-driven approach ensure you get unbiased guidance — free from dealership or brand influence. Every recommendation is tailored to your needs, your budget, and the assurance that you’re making the right decision
                </p>
              </div>
              <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
                <button 
                  onClick={scrollToContact}
                  className="bg-gradient-to-r from-blue-600 to-cyan-600 text-white px-8 py-4 rounded-full font-semibold text-lg hover:from-blue-700 hover:to-cyan-700 transition-all duration-300 transform hover:scale-105 shadow-2xl"
                >
                  Get My Car Deal Analysis
                </button>
                <button 
                  onClick={() => document.getElementById('how-it-works').scrollIntoView({ behavior: 'smooth' })}
                  className="border-2 border-white/30 text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white/10 transition-all duration-300 backdrop-blur-sm"
                >
                  Learn How It Works
                </button>
              </div>
              {/* <div className="flex items-center space-x-8 pt-4">
                <div className="text-center">
                  <div className="text-3xl font-bold text-white">$4.2K</div>
                  <div className="text-white/60 text-sm">Average Savings</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-white">3 Days</div>
                  <div className="text-white/60 text-sm">Average Process</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-white">95%</div>
                  <div className="text-white/60 text-sm">Success Rate</div>
                </div>
              </div> */}
            </div>
            <div className={`relative transition-all duration-1000 transform ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-12 opacity-0'}`}>
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 rounded-3xl transform rotate-3"></div>
                <div className="relative overflow-hidden rounded-3xl shadow-2xl h-96 lg:h-[500px]">
                  <div
                    className="flex h-full transition-transform duration-700 ease-out"
                    style={{ transform: `translateX(-${currentLandingImage * 100}%)` }}
                  >
                    {landingImages.map((image, index) => (
                      <img
                        key={index}
                        src={image}
                        alt="Happy customer with their new car"
                        className="w-full flex-shrink-0 h-96 lg:h-[500px] object-cover"
                      />
                    ))}
                  </div>
                </div>
                {/* <div className="absolute -bottom-6 -left-6 bg-white/95 backdrop-blur-sm rounded-2xl p-6 shadow-2xl border border-white/20">
                  <div className="flex items-center space-x-3">
                    <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-emerald-500 rounded-full flex items-center justify-center">
                      <span className="text-white text-2xl">✓</span>
                    </div>
                    <div>
                      <div className="font-bold text-gray-800">Deal Completed!</div>
                      <div className="text-gray-600 text-sm">Saved $5,200 on dream car</div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 px-4 bg-white/5 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Why Choose <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">{ companyNameText }</span>
            </h2>
            <p className="text-xl text-white/70 max-w-3xl mx-auto">
              We’re not tied to any dealer,  brand, or platform. Our only goal is to help you buy the right car — smartly, confidently, and stressfree
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch justify-items-center md:justify-items-stretch">
            {services.map((service, index) => (
              <div key={index} className="group h-full w-full">
                <div 
                  className={`flip-card relative min-h-[380px] h-full w-full cursor-pointer ${flippedCards[index] ? 'flipped' : ''}`}
                  onClick={() => toggleServiceCard(index)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') toggleServiceCard(index); }}
                >
                  <div className="flip-inner h-full">
                    {/* Front */}
                    <div className="flip-front h-full flex flex-col bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl min-h-[360px]">
                      <div className="relative mb-6">
                        <img 
                          src={service.image} 
                          alt={service.title}
                          className="w-full h-48 object-cover rounded-2xl opacity-80 group-hover:opacity-100 transition-opacity duration-300"
                        />
                      </div>
                      <h3 className="text-2xl font-bold text-white mb-4">{service.title}</h3>
                    </div>

                    {/* Back */}
                    <div className="flip-back h-full flex flex-col justify-center bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20 min-h-[360px]">
                      <h3 className="text-2xl font-bold text-white mb-4">{service.title}</h3>
                      <p className="text-white/70 leading-relaxed">{service.description}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Packages Section */}
      <section id="packages" className="py-20 px-4 bg-white/5 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Packages
            </h2>
            <p className="text-xl text-white/70 max-w-3xl mx-auto">
              Pick the level of concierge support that fits your buying journey, each designed to simplify every decision.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 items-stretch">
            {packages.map((pkg, index) => (
              <div key={index} className="group h-full">
                <div
                  className={`flip-card relative min-h-[380px] h-full cursor-pointer ${flippedPackages[index] ? 'flipped' : ''}`}
                  onClick={() => togglePackageCard(index)}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') togglePackageCard(index); }}
                >
                  <div className="flip-inner h-full">
                    {/* Front */}
                    <div className="flip-front h-full flex flex-col bg-white/10 backdrop-blur-lg rounded-3xl p-0 border border-white/20 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl min-h-[360px] overflow-hidden">
                      <img
                        src={pkg.image}
                        alt="Package visual"
                        className="w-full h-full object-cover"
                      />
                    </div>

                    {/* Back */}
                    <div className="flip-back h-full flex flex-col justify-center bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20 min-h-[360px]">
                      <p className="text-white/70 leading-relaxed">
                        {pkg.description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Us Section (unique content, no duplicate services) */}
      <section id="aboutus" className="py-20 px-4 bg-white/5 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              About <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">{companyNameText}</span>
            </h2>
            <p className="text-xl text-white/70 max-w-3xl mx-auto">
              iAutoCrew Solutions Inc. is your independent car-buying partner, dedicated to helping you find the right vehicle without dealership pressure or brand bias. With our research-driven approach, we simplify the process, save you money, and give you the confidence to make the best decision for your needs and budget.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20">
              <h3 className="text-2xl font-bold text-white mb-4">Our Vision</h3>
              <p className="text-white/70 leading-relaxed">
                Our vision is to redefine the car-buying experience by becoming the most trusted consumer-first automotive consulting service. We aspire to build a future where every car buyer — from first-time drivers to families upgrading their vehicles — can rely on unbiased guidance, data-backed insights, and seamless support to make confident decisions. By leveraging technology, expanding our services, and keeping customer trust at the core, we aim to set the standard for transparent, stress-free car buying worldwide.
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20">
              <h3 className="text-2xl font-bold text-white mb-4">What Sets Us Apart</h3>
              <ul className="text-white/70 space-y-2 list-disc pl-6 sm:pl-8">
                <li className="text-center sm:text-left"><b>Independent & Brand Neutral</b> — we don’t work for dealers, we work for you.</li>
                <li className="text-center sm:text-left"><b>Research-Driven</b> — every recommendation is backed by data, not sales pressure.</li>
                <li className="text-center sm:text-left"><b>Simple & stress-free</b> — no pushy negotiations, just clear guidance.</li>
                <li className="text-center sm:text-left"><b>Customer-focused</b> — built around your needs, your budget, your choice.</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how-it-works" className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              How It <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">Works</span>
            </h2>
            <p className="text-xl text-white/70 max-w-3xl mx-auto">
              Our proven 3-step process makes car buying effortless and ensures you get the best deal possible.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8 items-stretch">
            {[
              {
                step: "01",
                title: "Let's Learn About You",
                description: "We start by understanding your unique needs — budget, driving habits, lifestyle, and must-have features. Through a short call or intake form, we capture what matters most, from  technical aspects,  cost, safety,  comfort and ratings. This ensures our search is tailored entirely around you.",
                icon: "💬"
              },
              {
                step: "02", 
                title: "We Perform The Research",
                description: "We dive deep into the best-fit models, building a comparison chart that includes reliability, safety, ownership cost, resale value, fuel economy, pricing trends, and maintenance. We also conduct a Pricing & Value Analysis to define fair ranges and market trends. Finally, we deliver a Value Scorecard, ranking all shortlisted listings by deal quality, safety, and overall value — so you know exactly which option is your best pick.",
                icon: "🔍"
              },
              {
                step: "03",
                title: "Get Your Car",
                description: "We’ll handle the research, comparisons, negotiation, and closing — all with full transparency and zero dealership pressure. From reviewing dealer quotes to checking paperwork and guiding trade-ins or financing options, we make sure every detail is covered. The process is simple, stress-free, and ends with you driving the right car at the right price",
                icon: "🚗"
              }
            ].map((step, index) => (
              <div key={index} className="relative flex">
                <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20 hover:bg-white/20 transition-all duration-500 flex flex-col flex-1 min-h-[520px]">
                  <div className="text-6xl mb-6 opacity-20 font-bold text-white">{step.step}</div>
                  <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full flex items-center justify-center text-3xl mb-6 shadow-lg">
                    {step.icon}
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-4">{step.title}</h3>
                  <p className="text-white/70 leading-relaxed flex-1">{step.description}</p>
                </div>
                {index < 2 && (
                  <div className="hidden md:block absolute -right-8 top-1/2 transform -translate-y-1/2">
                    <div className="w-8 h-8 text-white/30">
                      <svg fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      {/* <section id="testimonials" className="py-20 px-4 bg-white/5 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              What Our <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">Clients Say</span>
            </h2>
            <p className="text-xl text-white/70 max-w-3xl mx-auto">
              Join thousands of satisfied customers who saved money and time with our expert car buying service.
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20 hover:bg-white/20 transition-all duration-500">
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <span key={i} className="text-yellow-400 text-xl">⭐</span>
                  ))}
                </div>
                <p className="text-white/80 leading-relaxed mb-6 text-lg italic">"{testimonial.content}"</p>
                <div>
                  <div className="font-bold text-white">{testimonial.name}</div>
                  <div className="text-white/60 text-sm">{testimonial.role}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* FAQ Section */}
      <section className="py-20 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Frequently Asked <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">Questions</span>
            </h2>
            <p className="text-xl text-white/70">
              Got questions? We've got answers. Here are the most common questions about our service.
            </p>
          </div>
          
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white/10 backdrop-blur-lg rounded-2xl border border-white/20 overflow-hidden">
                <button
                  onClick={() => toggleAccordion(index)}
                  className="w-full px-8 py-6 text-left flex justify-between items-center hover:bg-white/5 transition-colors duration-300"
                >
                  <span className="text-white font-semibold text-lg">{faq.question}</span>
                  <span className={`text-white/60 text-2xl transition-transform duration-300 ${activeAccordion === index ? 'rotate-45' : ''}`}>
                    +
                  </span>
                </button>
                {activeAccordion === index && (
                  <div className="px-8 pb-6">
                    <p className="text-white/70 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section id="contact" className="py-20 px-4 bg-gradient-to-r from-blue-600/20 to-cyan-600/20">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
            Ready to Get Your <span className="bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent">Best Car Deal?</span>
          </h2>
          <p className="text-xl text-white/80 mb-10 max-w-2xl mx-auto">
            Your dream car is just one click away.
          </p>
          
          <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 border border-white/20 max-w-md mx-auto">
            {formStatus.isSubmitted ? (
              <div className="text-center">
                <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white text-2xl">✓</span>
                </div>
                <h3 className="text-2xl font-bold text-white mb-2">Thank You!</h3>
                <p className="text-white/80 mb-4">
                  Your request has been submitted successfully. Our team will contact you within 24 hours to discuss your car buying needs.
                </p>
                <button 
                  onClick={() => setFormStatus({ isSubmitting: false, isSubmitted: false, error: null })}
                  className="text-blue-400 hover:text-blue-300 transition-colors duration-300"
                >
                  Submit Another Request
                </button>
              </div>
            ) : (
              <form onSubmit={handleContactSubmit} className="space-y-6">
                {formStatus.error && (
                  <div className="bg-red-500/20 border border-red-500/50 rounded-xl p-4 text-red-200 text-center">
                    {formStatus.error}
                  </div>
                )}
                <div>
                  <input 
                    type="text" 
                    name="name"
                    value={contactForm.name}
                    onChange={handleInputChange}
                    placeholder="Your Name *"
                    required
                    className="w-full px-4 py-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-300"
                  />
                </div>
                <div>
                  <input 
                    type="email" 
                    name="email"
                    value={contactForm.email}
                    onChange={handleInputChange}
                    placeholder="Your Email *"
                    required
                    className="w-full px-4 py-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-300"
                  />
                </div>
                <div>
                  <input 
                    type="tel" 
                    name="phone"
                    value={contactForm.phone}
                    onChange={handleInputChange}
                    placeholder="Your Phone (10 digits) *"
                    required
                    pattern="[0-9]{10}"
                    maxLength={10}
                    inputMode="numeric"
                    title="Enter a 10-digit phone number"
                    className="w-full px-4 py-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-300"
                  />
                </div>
                <div>
                  <textarea 
                    name="car_preferences"
                    value={contactForm.car_preferences}
                    onChange={handleInputChange}
                    placeholder="What car are you looking for? (e.g., Toyota Camry, budget $25k, need within 2 weeks) *"
                    rows="3"
                    required
                    className="w-full px-4 py-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all duration-300 resize-none"
                  ></textarea>
                </div>
                <button 
                  type="submit"
                  disabled={formStatus.isSubmitting}
                  className="w-full bg-gradient-to-r from-blue-600 to-cyan-600 text-white px-8 py-4 rounded-xl font-semibold text-lg hover:from-blue-700 hover:to-cyan-700 transition-all duration-300 transform hover:scale-105 shadow-2xl disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                >
                  {formStatus.isSubmitting ? (
                    <div className="flex items-center justify-center space-x-2">
                      <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
                      <span>Submitting...</span>
                    </div>
                  ) : (
                    'Get My Free Car Deal Analysis'
                  )}
                </button>
              </form>
            )}
          </div>
          
          <div className="mt-8 flex items-center justify-center space-x-6 text-white/60">
            <div className="flex items-center space-x-2">
              <span className="w-5 h-5 text-green-400">✓</span>
              <span>Free Consultation</span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="w-5 h-5 text-green-400">✓</span>
              <span>No Obligation</span>
            </div>
            <div className="flex items-center space-x-2">
              <span className="w-5 h-5 text-green-400">✓</span>
              <span>Expert Guidance</span>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-12 px-4 bg-black/20 backdrop-blur-sm border-t border-white/10">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <div className="flex items-center space-x-2 mb-4">
                <img src={companyName} alt={companyNameText} className="h-10 md:h-12 w-auto object-contain" />
              </div>
              <p className="text-white/60 mb-6 max-w-md">
                Your trusted partner in finding the perfect car deal. We simplify the process and save you money.
              </p>
              <div className="flex space-x-4">
                <a
                  href="https://x.com/iautocrew"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="iAutoCrew on X"
                  className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center text-white/60 hover:text-white hover:bg-white/20 transition-colors duration-300"
                >
                  <span>t</span>
                </a>
              </div>
            </div>
            
            <div>
              {/* <h4 className="text-white font-semibold mb-4">Services</h4> */}
              <ul className="space-y-2 text-white/60">
                {/* <li><a href="#" className="hover:text-white transition-colors duration-300">Car Deal Analysis</a></li>
                <li><a href="#" className="hover:text-white transition-colors duration-300">Expert Negotiation</a></li>
                <li><a href="#" className="hover:text-white transition-colors duration-300">Process Simplification</a></li>
                <li><a href="#" className="hover:text-white transition-colors duration-300">Financing Assistance</a></li> */}
              </ul>
            </div>
            
            <div>
              <h4 className="text-white font-semibold mb-4">Contact</h4>
              <ul className="space-y-2 text-white/60">
                <li>
                  <a
                    href="tel:+17429882445"
                    onClick={handlePhoneCallClick}
                    className="hover:text-white transition-colors duration-300"
                  >
                    📞 (742) 988-2445
                  </a>
                </li>
                <li>✉️ contact@iautocrewsolutions.ca</li>
                <li>🌐 www.iautocrewsolutions.ca</li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-white/10 mt-8 pt-8 text-center text-white/60">
            <p>&copy; 2025 iAutocrewsolutions. All rights reserved. | Privacy Policy | Terms of Service</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;
